// Auth mutations. better-auth owns the primitives server-side (basePath /v1/auth);
// the CMS just posts credentials and relies on the HttpOnly session cookie for
// subsequent requests. The concrete route names below are better-auth's own
// (sign-in/email, sign-out); accept-invite is our custom route that creates the
// account, opens a session, and returns the `Me` payload.
import { request } from './client.ts';
import type { Me } from '@seencast/shared';

export interface LoginBody {
  email: string;
  password: string;
}
export interface AcceptInviteBody {
  token: string;
  name: string;
  password: string;
}

/** better-auth email sign-in. Sets the session cookie; the caller then loads /me. */
export function login(body: LoginBody): Promise<unknown> {
  return request<unknown>('/auth/sign-in/email', { method: 'POST', body });
}

export function logout(): Promise<unknown> {
  return request<unknown>('/auth/sign-out', { method: 'POST' });
}

/** Custom route: accepts the invite, opens a session, and returns the user + orgs. */
export function acceptInvite(body: AcceptInviteBody): Promise<Me> {
  return request<Me>('/auth/accept-invite', { method: 'POST', body });
}
